export class EventSuccess {
  private callback: string;
  private success: boolean;
  private type: string;

  constructor() {
    this.callback = 'Success';
    this.success = true;
  }

  public setType(isUsaContract: boolean) {
    this.type = isUsaContract ? 'Trading Global' : 'Trading';
  }

  public getType(): string {
    return this.type;
  }

  public getEventSuccess() {
    if (this.type) {
      return {
        Callback: this.callback,
        Success: this.success,
        Type: this.type,
      };
    }

    return {
      Callback: this.callback,
      Success: this.success,
    };
  }
}
